import { ActionType } from '../action-types';
import loginPageInitialState from './init/loginPageInitialState';

const loginPageReducer = (state = loginPageInitialState, action) => {
	switch (action.type) {
		case ActionType.LOGIN_SUCCESS:
			return {
				...state,
				token: action.token,
				username: action.username,
				loggedUserId: action.loggedUserId,
				success: true,
				email: action.email,
				accountCategory: action.accountCategory,
				showError: false,
			};
		case ActionType.LOGIN_FAILED:
			return {
				...state,
				success: false,
				showError: true,
				cardAnimation: '',
				clickedButtonDisabled: false,
				error: action.error,
			};
		case ActionType.REFRESH_USER_NAME:
			return {
				...state,
				username: action.account.name,
			};
		case ActionType.SHOW_CARD:
			return {
				...state,
				cardAnimation: '',
			};
		case ActionType.CLOSE_ERROR:
			return {
				...state,
				showError: false,
			};
		case ActionType.LOGOUT:
			return {
				...loginPageInitialState,
				token: '',
			};
		case ActionType.RESETTING_PASSWORD_SUCCEED:
			return {
				...state,
				resettingPasswordFailed: false,
				resettingPasswordSucceed: true,
				resetPasswordTimeoutFailed: false,
			};
		case ActionType.RESETTING_PASSWORD_FAILED:
			return {
				...state,
				resettingPasswordSucceed: false,
				resettingPasswordFailed: true,
				resetPasswordTimeoutFailed: false,
			};
		case ActionType.CLOSE_SAVE_PASSWORD_NOTIFICATION:
			return {
				...state,
				resettingPasswordFailed: false,
				resettingPasswordSucceed: false,
				resetPasswordTimeoutFailed: false,
			};
		case ActionType.RESET_PASSWORD_TIMEOUT_FAILED:
			return {
				...state,
				resettingPasswordFailed: false,
				resettingPasswordSucceed: false,
				resetPasswordTimeoutFailed: true,
			};
		case ActionType.GET_CENSORED_MAIL:
			return {
				...state,
				changedPasswordEmail: action.changedPasswordEmail,
				changedPasswordEmailCardHeader: action.changedPasswordEmailCardHeader,
				incorrectToken: false,
			};
		case ActionType.GET_CENSORED_MAIL_FAIL:
			return {
				...state,
				incorrectToken: true,
			};
		case ActionType.TOGGLE_DISABLE_BUTTON:
			return {
				...state,
				clickedButtonDisabled: true,
			};
		default:
			return state;
	}
};

export default loginPageReducer;
